<div class="flex text-center mb-8 bg-white">
  <div class="stat-block flex-1" [class.active]="activeFilter === null && !hasOtherFiltersActive" (click)="filterChange.emit(null)">
    <nz-statistic [nzValue]="(emailTotal | number)!" nzTitle="Total"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'sent'" (click)="filterChange.emit('sent')">
    <nz-statistic [nzValue]="(emailSent | number)!" nzTitle="Sent"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'opened'" (click)="filterChange.emit('opened')">
    <nz-statistic [nzValue]="(emailOpened | number)!" nzTitle="Opened"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'bounced'" (click)="filterChange.emit('bounced')">
    <nz-statistic [nzValue]="(emailBounced | number)!" nzTitle="Bounced"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'unsubscribed'" (click)="filterChange.emit('unsubscribed')">
    <nz-statistic [nzValue]="(emailUnsubscribed | number)!" nzTitle="Unsubscribed"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'skip'" (click)="filterChange.emit('skip')">
    <nz-statistic [nzValue]="(emailSkip | number)!" nzTitle="Skip"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'acknowledge'" (click)="filterChange.emit('acknowledge')">
    <nz-statistic [nzValue]="(emailAcknowledge | number)!" nzTitle="Acknowledge"></nz-statistic>
  </div>
</div>
